function scrollspy() {
	//scrollspy target
	$('body').scrollspy({ target: '#navbar-example' })
}

export { scrollspy as default };